import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

let searchParameter = {};

export function getSectionDataByDefault({ sectionName, parameter, data, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter }, state: data.Data });
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  searchParameter['moduleId'] = parameter;
  sectionComponent.setState({ searchParameter, componentDefaultValue });
  sectionComponent.customForm.current?.setState({ componentDataSource: [] });

  httpClient
    .get('/System/ModuleConfig/GetByModuleId?moduleId=' + parameter)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.setState({ country: data.data.Module.Country, sectionComponent, ModuleConfig: data.data });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });

  setTimeout(() => {
    sectionComponent.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}

export function keywordChange({ sectionName, parameter, sectionComponent, pageComponent, formComponent, uie }) {
  searchParameter['keyword'] = parameter;
}

export function search({ sectionName, parameter, sectionComponent, pageComponent, formComponent, uie }) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue['Keyword'] = searchParameter['keyword'];
  sectionComponent.setState({ searchParameter, componentDefaultValue });

  let pagination = sectionComponent.child.current?.state.pagination;
  pagination.current = 1;
  sectionComponent.child.current?.setState({ pagination });

  setTimeout(() => {
    sectionComponent.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}

export function onKeyDown({ sectionName, parameter, sectionComponent, pageComponent, formComponent, uie }) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue['Keyword'] = parameter;
  sectionComponent.setState({ searchParameter, componentDefaultValue });

  let pagination = sectionComponent.child.current?.state.pagination;
  pagination.current = 1;
  sectionComponent.child.current?.setState({ pagination });

  setTimeout(() => {
    sectionComponent.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}

export function clearSearch({ sectionName, parameter, sectionComponent, pageComponent, formComponent, uie }) {
  searchParameter['keyword'] = '';
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue['Keyword'] = '';
  sectionComponent.setState({ searchParameter, componentDefaultValue });

  let pagination = sectionComponent.child.current?.state.pagination;
  pagination.current = 1;
  sectionComponent.child.current?.setState({ pagination });

  setTimeout(() => {
    sectionComponent.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}

let setAutoComplete = false;
//Search Address从google map找自动完成地址的数据源
export function searchAddressChange({ sectionName, parameter, sectionComponent, pageComponent, formComponent, uie } = {}) {
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && setAutoComplete === false) {
    setAutoComplete = true;

    let options = {
      componentRestrictions: {
        country: [pageComponent.state.country]
      }
    };

    var input = document.getElementById('CompanyContactSearchAddress');
    var autocomplete = new window.google.maps.places.Autocomplete(input, options);

    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      if (place.place_id.length > 150) {
        message.warning('The address you selected does not exist. Please select another one.');
      } else {
        for (var i = 0; i < place.address_components.length; i++) {
          switch (pageComponent.state.country.toLowerCase()) {
            case 'nz':
              if (place.address_components[i].types[0] == "street_number") {
                formComponent.formRef.current?.setFieldValue('StreetNumber', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "route") {
                formComponent.formRef.current?.setFieldValue('StreetName', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "sublocality_level_1") {
                formComponent.formRef.current?.setFieldValue('Suburb', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "locality") {
                formComponent.formRef.current?.setFieldValue('CityTown', place.address_components[i].short_name);
              }
              if (place.address_components[i].types[0] == "postal_code") {
                formComponent.formRef.current?.setFieldValue('Postcode', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "country") {
                formComponent.formRef.current?.setFieldValue('Country', place.address_components[i].long_name);
              }
              break;
            default:
              if (place.address_components[i].types[0] == "street_number") {
                formComponent.formRef.current?.setFieldValue('StreetNumber', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "route") {
                formComponent.formRef.current?.setFieldValue('StreetName', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "locality") {
                formComponent.formRef.current?.setFieldValue('Suburb', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "administrative_area_level_1") {
                formComponent.formRef.current?.setFieldValue('State', place.address_components[i].short_name);
              }
              if (place.address_components[i].types[0] == "postal_code") {
                formComponent.formRef.current?.setFieldValue('Postcode', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "country") {
                formComponent.formRef.current?.setFieldValue('Country', place.address_components[i].long_name);
              }
              break;
          }
        }
        formComponent.formRef.current?.setFieldValue('CompanyContactSearchAddress', place.formatted_address);
      }
    })
  }
}

export function addCompanyContactPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setTimeout(() => {
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ State: pageComponent.state.ModuleConfig.DefaultState, PostalState: pageComponent.state.ModuleConfig.DefaultState, Country: pageComponent.state.ModuleConfig.DefaultCountry, PostalCountry: pageComponent.state.ModuleConfig.DefaultCountry });
  }, config.setTimeoutMilliSecond);
  setAutoComplete = false;
}

export function getStateDataSourceRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (sectionComponent.state.componentType == 'Create') {
    setTimeout(() => {
      sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ State: pageComponent.state.ModuleConfig.DefaultState, PostalState: pageComponent.state.ModuleConfig.DefaultState, Country: pageComponent.state.ModuleConfig.DefaultCountry, PostalCountry: pageComponent.state.ModuleConfig.DefaultCountry });
    }, config.setTimeoutMilliSecond);
    setAutoComplete = false;
  }
}

export function getPostalStateDataSourceRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (sectionComponent.state.componentType == 'Create') {
    setTimeout(() => {
      sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ State: pageComponent.state.ModuleConfig.DefaultState, PostalState: pageComponent.state.ModuleConfig.DefaultState, Country: pageComponent.state.ModuleConfig.DefaultCountry, PostalCountry: pageComponent.state.ModuleConfig.DefaultCountry });
    }, config.setTimeoutMilliSecond);
    setAutoComplete = false;
  }
}

export function editCompanyContactPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setAutoComplete = false;
}

//选Same As Address时给Postal Address赋值
export function setSameAsAddress({ sectionName, parameter, sectionComponent, pageComponent, formComponent, uie }) {
  if (parameter) {
    formComponent.formRef.current?.setFieldValue('PostalStreetNumber', formComponent.formRef.current?.getFieldValue('StreetNumber'));
    formComponent.formRef.current?.setFieldValue('PostalStreetName', formComponent.formRef.current?.getFieldValue('StreetName'));
    formComponent.formRef.current?.setFieldValue('PostalSuburb', formComponent.formRef.current?.getFieldValue('Suburb'));
    formComponent.formRef.current?.setFieldValue('PostalState', formComponent.formRef.current?.getFieldValue('State'));
    formComponent.formRef.current?.setFieldValue('PostalCityTown', formComponent.formRef.current?.getFieldValue('CityTown'));
    formComponent.formRef.current?.setFieldValue('PostalPostcode', formComponent.formRef.current?.getFieldValue('Postcode'));
    formComponent.formRef.current?.setFieldValue('PostalCountry', formComponent.formRef.current?.getFieldValue('Country'));
  } else {
    formComponent.formRef.current?.setFieldValue('PostalStreetNumber', '');
    formComponent.formRef.current?.setFieldValue('PostalStreetName', '');
    formComponent.formRef.current?.setFieldValue('PostalSuburb', '');
    formComponent.formRef.current?.setFieldValue('PostalState', '');
    formComponent.formRef.current?.setFieldValue('PostalCityTown', '');
    formComponent.formRef.current?.setFieldValue('PostalPostcode', '');
    formComponent.formRef.current?.setFieldValue('PostalCountry', '');
  }
}

export function subContactsShow({ sectionName, parameter, sectionComponent, pageComponent, formComponent, uie }) {
  pageComponent.setState({ currentCompanyContact: parameter, manageCompanySubContactShow: true });
  setTimeout(() => {
    pageComponent.manageCompanySubContact.current?.getCompanySubContactList();
  }, config.setTimeoutMilliSecond);
}

//CompanyContact列表下载Excel
export function exportToExcel({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.download({ method: 'post', url: '/Admin/CompanyContact/GenerateExcel', filename: 'Company Contact.xlsx', save: true });
}

export function submitCustomForm({ parameter, sectionComponent, pageComponent, formComponent, sectionName } = {}) {
  if (sectionComponent.state.componentType === 'Create') {
    let form = sectionComponent.customForm.current?.formRef.current?.getFieldsValue();
    form.ModuleId = sectionComponent.state.searchParameter.moduleId;
    httpClient
      .post('Admin/CompanyContact/CheckExisting', form)
      .then(({ data }) => {
        if (data.result) {
          if (data.data === false) {
            sectionComponent.customForm.current?.submitForm();
          } else {
            message.error('Contact already exists.');
          }
        } else {
          globalFunction.handleResultError(data);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  } else {
    sectionComponent.customForm.current?.submitForm();
  }
}
